import getCards from 'app/games/whoisit/selectors/getCards';

function getCard(state, id) {
  return getCards(state).find(card => card.id === id);
}

export default getCard;
